import { createTheme } from '@mui/material/styles';

/** Brand accent for selections (slots, variants, chips, radios, etc.) */
export const V2_PRIMARY_MAIN = 'rgb(164, 36, 61)';

export const v2MuiTheme = createTheme({
  palette: {
    primary: {
      main: V2_PRIMARY_MAIN,
    },
  },
  components: {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          '&.Mui-selected': {
            color: '#fff',
            backgroundColor: V2_PRIMARY_MAIN,
            '&:hover': {
              backgroundColor: V2_PRIMARY_MAIN,
              opacity: 0.92,
            },
          },
        },
      },
    },
  },
});
